module.exports = __webpack_public_path__ + "img/category03.1802498c.png";